module.exports = "/_next/static/images/kammerkollegiet-ed98ebedc0515de424f748abfd08d125.svg";